const defaultValue = {
    count: {
        value: 0,
        formatted: '0',
        suffix: '',
        prefix: '',
        percent: 0,
    },
    amount: {
        value: 0,
        formatted: '0.00',
        suffix: '',
        prefix: '$',
        percent: 0,
    },
    htmlUrl: '#',
};

const base = {
    type: 'dashboards',
    name: '',
    averageTime: {},
    dashboardType: 'funnel',
    previousLeads: defaultValue,
    advancedLeads: defaultValue,
    totalLeads: defaultValue,
    currentLeads: defaultValue,
    addedLeads: defaultValue,
    regressedLeads: defaultValue,
    regressingLeads: defaultValue,
    closedLeads: defaultValue,
    wonLeads: defaultValue,
    lostLeads: defaultValue,
    reassignedLeads: defaultValue,
    cancelledLeads: defaultValue,
};

export default {
    meta: {
        hasLeads: true,
        count: 28,
    },
    dashboards: [
        Object.assign({}, base, {id: '1', links: {stage: '1-stages'}}),
        Object.assign({}, base, {id: '2', links: {stage: '2-stages'}}),
        Object.assign({}, base, {id: '3', links: {stage: '3-stages'}}),
        Object.assign({}, base, {id: '4', links: {stage: '4-stages'}}),
        Object.assign({}, base, {id: '5', links: {stage: '5-stages'}}),
        Object.assign({}, base, {id: '6', links: {stage: '6-stages'}}),
    ],
};
